import React from 'react';
import { Table, Icon, Button, Input, Tag } from 'antd';
import { translate } from 'react-i18next';
import { compose } from 'redux';
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
import { pathOr } from 'ramda'
import moment from 'moment'

class STAdminUsers extends React.Component {

  state = {
    sorter: {
      columnKey: 'firstname',
      field: 'firstname',
      order: 'ascend'
    },
    filters: {}
  }

  setFilter = (column, value) => {
    let { filters } = this.state
    if (value === null) {
      delete filters[column]
    } else {
      filters[column] = value
    }
    this.setState({ filters })
  }

  sortColumn = (a, b, column) => {
    const compareA = Number.isInteger(a[column]) ? a[column] :
      typeof a[column] && a[column] === 'string'
        ? a[column].toLowerCase()
        : a[column]
    const compareB = Number.isInteger(b[column]) ? b[column] :
      typeof b[column] && b[column] === 'string'
        ? b[column].toLowerCase()
        : b[column]
    return (
      compareA === compareB ? 0 :
        (compareA > compareB ? 1 : -1)
    )
  }

  getColumns = () => {

    const { sorter, filters } = this.state
    const { t } = this.props

    return [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: (a, b) => this.sortColumn(a, b, 'name'),
        sortOrder: sorter.columnKey === 'name' && sorter.order,
        filterIcon: () => <Icon type="search" style={{ color: filters.first ? '#1890ff' : '#000000a6' }} />,
        filterDropdown: () => (
          <div style={{ padding: 10 }}>
            <Input placeholder={t("Search")} style={{ height: 30, marginBottom: 10 }} value={filters.name} onChange={e => this.setFilter('name', e.target.value)} />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Button id="reset" onClick={() => this.setFilter('name', null)}>{t('Reset')}</Button>
            </div>
          </div>
        ),
      },
      {
        title: 'Grade',
        dataIndex: 'grade',
        key: 'grade',
        sorter: (a, b) => this.sortColumn(a, b, 'grade'),
        sortOrder: sorter.columnKey === 'grade' && sorter.order,
        filterIcon: () => <Icon type="search" style={{ color: filters.first ? '#1890ff' : '#000000a6' }} />,
        filterDropdown: () => (
          <div style={{ padding: 10 }}>
            <Input placeholder={t("Search")} style={{ height: 30, marginBottom: 10 }} value={filters.grade} onChange={e => this.setFilter('grade', e.target.value)} />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Button id="reset" onClick={() => this.setFilter('grade', null)}>{t('Reset')}</Button>
            </div>
          </div>
        ),
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        sorter: (a, b) => this.sortColumn(a, b, 'email'),
        sortOrder: sorter.columnKey === 'email' && sorter.order,
        filterIcon: () => <Icon type="search" style={{ color: filters.first ? '#1890ff' : '#000000a6' }} />,
        filterDropdown: () => (
          <div style={{ padding: 10 }}>
            <Input placeholder={t("Search")} style={{ height: 30, marginBottom: 10 }} value={filters.email} onChange={e => this.setFilter('email', e.target.value)} />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Button id="reset" onClick={() => this.setFilter('email', null)}>{t('Reset')}</Button>
            </div>
          </div>
        ),
      },
      {
        title: 'Birthdate',
        dataIndex: 'birthdate',
        key: 'birthdate',
        sorter: (a, b) => this.sortColumn(a, b, 'birthdate'),
        sortOrder: sorter.columnKey === 'birthdate' && sorter.order,
        filterIcon: () => <Icon type="search" style={{ color: filters.first ? '#1890ff' : '#000000a6' }} />,
        filterDropdown: () => (
          <div style={{ padding: 10 }}>
            <Input placeholder={t("Search")} style={{ height: 30, marginBottom: 10 }} value={filters.birthdate} onChange={e => this.setFilter('birthdate', e.target.value)} />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Button id="reset" onClick={() => this.setFilter('birthdate', null)}>{t('Reset')}</Button>
            </div>
          </div>
        ),
      },
      {
        title: 'School name',
        dataIndex: 'school',
        key: 'school',
        sorter: (a, b) => this.sortColumn(a, b, 'school'),
        sortOrder: sorter.columnKey === 'school' && sorter.order,
        filterIcon: () => <Icon type="search" style={{ color: filters.first ? '#1890ff' : '#000000a6' }} />,
        filterDropdown: () => (
          <div style={{ padding: 10 }}>
            <Input placeholder={t("Search")} style={{ height: 30, marginBottom: 10 }} value={filters.school} onChange={e => this.setFilter('school', e.target.value)} />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Button id="reset" onClick={() => this.setFilter('school', null)}>{t('Reset')}</Button>
            </div>
          </div>
        ),
      },
      {
        title: 'Is Paid',
        dataIndex: 'paid',
        key: 'paid',
        sorter: (a, b) => this.sortColumn(a, b, 'paid'),
        sortOrder: sorter.columnKey === 'paid' && sorter.order,
      },
      {
        title: 'Date of registration',
        dataIndex: 'registration',
        key: 'registration',
        sorter: (a, b) => this.sortColumn(a, b, 'registration'),
        sortOrder: sorter.columnKey === 'registration' && sorter.order,
        render: timestamp => timestamp === 'N/A' ? timestamp : moment(timestamp).format('DD/MM/YYYY')
      },
      {
        title: 'Date of trial',
        dataIndex: 'trial',
        key: 'trial',
        sorter: (a, b) => this.sortColumn(a, b, 'trial'),
        sortOrder: sorter.columnKey === 'trial' && sorter.order,
        render: timestamp => timestamp === 'N/A' ? timestamp : moment(timestamp).format('DD/MM/YYYY')
      },
      {
        title: 'Date of subscription',
        dataIndex: 'subscription',
        key: 'subscription',
        sorter: (a, b) => this.sortColumn(a, b, 'subscription'),
        sortOrder: sorter.columnKey === 'subscription' && sorter.order,
        render: timestamp => timestamp === 'N/A' ? timestamp : moment(timestamp).format('DD/MM/YYYY')
      },
      {
        title: 'Date of cancellation',
        dataIndex: 'cancellation',
        key: 'cancellation',
        sorter: (a, b) => this.sortColumn(a, b, 'cancellation'),
        sortOrder: sorter.columnKey === 'cancellation' && sorter.order,
        render: timestamp => timestamp === 'N/A' ? timestamp : moment(timestamp).format('DD/MM/YYYY')
      },
    ]
  }

  getTableData = () => {
    const { users } = this.props
    let tableData = []
    users.map( user => {
      let profile = user.value.profile
      tableData.push({
        name: profile.name,
        grade: profile.myp,
        email: profile.email,
        birthdate: profile.dob === 'Invalid date' ? '' : profile.dob,
        school: profile.school && profile.school.name,
        paid: pathOr([], ['value', 'subscription', 'dateOfSubscription'], user).length > 0 ? 'Yes' : 'No',
        registration: this.getDate(user.value, 'dateOfRegistration'),
        trial: this.getDate(user.value, 'dateOfTrial'),
        subscription: this.getDate(user.value, 'dateOfSubscription'),
        cancellation: this.getDate(user.value, 'dateOfCancellation')
      })
    })
    return tableData;
  }

  getDate = (user, type) => {
    if (type === 'dateOfRegistration') {
      let timestamp = pathOr(null, ['dateOfRegistration'], user)
      if (timestamp) {
        return timestamp
      } else {
        return 'N/A'
      }
    } else {
      let timestamps = pathOr([], ['subscription', type], user)
      if (timestamps.length > 0) {
        let timestamp = timestamps[timestamps.length - 1].date
        return timestamp
      } else {
        return 'N/A'
      }
    }

  }

  filterTableData = (tableData) => {
    const { filters } = this.state
    for (let key in filters) {
      tableData = tableData.filter(row => 
        typeof row[key] === 'string'
         ? row[key].toLowerCase().includes(filters[key].toLowerCase())
         : row[key] == filters[key]
      )
    }
    return tableData
  }

  render() {

    const { t } = this.props;

    let tableData = this.getTableData()
    tableData = this.filterTableData(tableData)

    return (
      <div>
        <div style={{overflow: 'hidden', padding: 20}}>
          <Icon style={styles.logout} type="unlock" onClick={() => this.props.firebase.logout()} />
        </div>
        <div style={styles.inner}>
          <Table
            onChange={(pagination, filters, sorter) => this.setState({sorter})}
            id='log-table'
            columns={this.getColumns()}
            scroll={{ x: 1500 }}
            dataSource={tableData}
          />
        </div>
      </div>
    )
  }
}

const enhancer = compose(
  translate('lang'),
  firebaseConnect((props) => {
    return [
      'users'
    ]
  }),
  connect(
    state => ({
      schools: state.firebase.data.schools,
      users: pathOr([], ['ordered', 'users'], state.firebase).filter(user => (
        Object.entries(user.value.roles)[0][1][0] === 'student'
      ))
    })
  )
)
export default enhancer(STAdminUsers);

const styles = {

  container: {
    padding: '20px'
  },

  logout: {
    fontSize: '30px',
    float: 'right',
    marginLeft: '10px',
    cursor: 'pointer'
  },

  buttonBlue: {
    float: 'right',
    fontSize: '17px',
    backgroundColor: '#4A90E2',
    border: 'none',
    fontSize: '14px',
    borderRadius: '15px'
  },

  submenu: {
    marginBottom: '20px',
    overflow: 'hidden'
  },

  inner: {
    padding: 20,
    backgroundColor: 'white',
    boxShadow: '0 1px 3px 1px rgba(119,151,178,0.16)'
  },

  dropdown: {
    width: 180,
    borderRadius: 25,
    marginRight: 10
  }
}



// WEBPACK FOOTER //
// ./src/containers/STAdminUsers/index.jsx